import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

/* eslint-disable-next-line */
export interface LIconCardProps {
  iconName: IconName;
  title: string;
  subTitle?: string;
  large?: boolean;
}

export function LIconCard(props: LIconCardProps) {
  return (
    <div
      className={clsx([
        props?.large ? "lg:w-96 lg:h-64" : "lg:w-64 lg:h-64",
        "flex flex-col items-center justify-center gap-5 bg-white rounded-xl shadow-lg w-2/5 h-auto p-5 text-center",
      ])}
    >
      <div>
        <FontAwesomeIcon
          icon={props?.iconName}
          className="text-3xl lg:text-6xl text-ekgreen"
        />
      </div>
      <div
        className={clsx([
          props?.large ? "text-3xl " : "text-lg",
          "font-extrabold",
        ])}
      >
        {props?.title}
      </div>
      {props?.subTitle && <div className="text-lg">{props?.subTitle}</div>}
    </div>
  );
}

export default LIconCard;
